<template>
  <v-container>
    <v-snackbar
      v-model="popup.visbile"
      :color="popup.type"
      :timeout="3000"
      :top="'top'"
      :bottom="false"
      class="custom-snackbar"
    >
      {{ popup.text }}
      <v-btn dark text @click="popup.visible = false">Close</v-btn>
    </v-snackbar>
    <div class="px-2 py-4">
      <div class="mb-6">
        <v-row>
          <v-col style="padding-left: 0px;">
            <div
              v-bind:style="{
                'border-radius': '4px',
                position: 'relative',
                display: 'inline-block',
                'box-sizing': 'border-box'
              }"
            >
              <input
                type="file"
                name="file"
                @change="filesChange($event.target.name, $event.target.files)"
                accept="image/*"
                v-bind:style="{
                  width: '4.375rem',
                  height: '4.375rem',
                  'border-radius': '5px',
                  'background-color': '#eee',
                  'background-repeat': 'no-repeat !important',
                  'background-size': 'contain !important',
                  'background-position': 'center !important',
                  'background-image':
                    setting.logo == '' || setting.logo == null
                      ? ''
                      : 'url(\'' + setting.logo + '\') !important',
                  overflow: 'hidden',
                  'padding-left': '4.375rem',
                  'box-shadow': '0px 0px 3px 3px rgba(0,0,0,0.2)'
                }"
              />
            </div>
            <v-icon
              style="top:20px;left:-57px;padding:1px;background-color:#eee;border-radius:3px;opacity:75%"
            >mdi-camera</v-icon>

            <v-tooltip left max-width="207" max-height="57">
              <template v-slot:activator="{ on }">
                <v-icon
                  class="help-icon"
                  v-on="on"
                  style="float:right;position: relative;top: 5px;"
                >mdi-help</v-icon>
              </template>
              <span>Logo shown in the top-left corner of the login box</span>
            </v-tooltip>
            <span
              style="display: inline-block;vertical-align: top;margin-top: 5px;width: 100px;"
              class="compact"
            >
              Add Brand Logo
              <br />
              <span style="color:#999;" class="small">.JPEG, .PNG</span>
            </span>
          </v-col>
        </v-row>
      </div>
      <div>
        <span class="fs-14 fw-700 mb-3 compact">
          Landing Page
          <v-tooltip left max-width="207" max-height="57">
            <template v-slot:activator="{ on }">
              <v-icon class="help-icon" v-on="on" style="float:right;">mdi-help</v-icon>
            </template>
            <span>Page user is shown after they complete the login process</span>
          </v-tooltip>
        </span>
        <v-text-field
          class="compact"
          label="URL"
          single-line
          v-model="setting.landingUrl"
        >{{ setting.landingUrl }}</v-text-field>
      </div>
    </div>
    <div class="pb-12 mx-4 float-right">
      <v-btn
        class="px-3"
        height="32"
        @click="preview()"
        style="background-color:#ecc94b !important;letter-spacing:normal;color:#666"
      >
        <span class="fs-12 text-capitalize">Page Preview</span>
      </v-btn>
    </div>
    <div class="pb-12 mt-12">
      <v-btn width="100%" height="48" @click="save()" id="submit">Save</v-btn>
    </div>
    <div
      v-if="nonPremium()"
      style="border:solid 1px red;margin-left:-5px;width:100%;background-color:rgba(255,255,255,0.9);display:block;height:400px;position:absolute;top:10px;text-align:center;"
    >
      <div style="display:block;position:relative;top:100px">
        <img src="~/img/locked.svg" />
        <span style="display:block;font-weight:bold;font-size:22px">Premium Feature</span>
        <span>PAY TO UPGRADE</span>
        <v-card height="55px" width="100%" color="#f3f3f3" class="upgrade-banner">
          <v-row>
            <v-col class="upgrade-banner-text-col">
              <ul class="upgrade-banner-text">
                <li>- Track your customers</li>
                <li>- Grow you business</li>
              </ul>
            </v-col>
            <v-col class="upgrade-banner-cta-col">
              <v-btn
                class="upgrade-banner-cta"
                color="#214294"
                style="color:white"
                @click="GoToPaymentPage()"
              >PAY TO UPGRADE</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <v-dialog v-model="showPlans" fullscreen hide-overlay transition="dialog-bottom-transition">
        <Plans v-bind:location="selectedLocation" v-bind:view="view" @close="showPlans = false"></Plans>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import WIOM_APIS from '../../utils/wiom-apis';
import Plans from "./../common/Plans";

export default {
  props: ["storeData", "selectedLocation", "settingId"],
  components: {
    Plans
  },
  data: function() {
    return {
      view: "",
      showPlans: false,
      setting: {
        logo: null,
        landingUrl: null
      },
      popup: {
        type: "success",
        visbile: false,
        text: ""
      },
      basicConfiguration: {},
      advancedConfiguration: {}
    };
  },
  mounted: function() {
    this.GetUserBasicConfig();
    this.GetAdvancedConfiguration();
  },
  methods: {
    nonPremium: function() {
      if (this.storeData == null || this.storeData.length < 1) return false;
      if (
        this.selectedLocation.subscription == null ||
        this.selectedLocation.subscription.active != true
      )
        return true;
      return false;
    },
    preview: function() {
      var uuidv4 = function() {
        return "xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      };

      var mockmac = function() {
        return "xx-xx-xx-xx-xx-xx".replace(/[xy]/g, function(c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16).toUpperCase();
        });
      };
      if (window.location.href.indexOf("localhost") >= 0) {
        var src =
          "https://localhost:44300?doTest&res=logoff&uamip=10.1.0.1&uamport=80&challenge=30f8c06d61d8142d81fbdb394640fc13&called=" +
          mockmac() +
          "&mac=" +
          mockmac() +
          "&power=32&ip=10.1.0.2&nasid=" +
          this.selectedLocation.nasid +
          "&sessionid=" +
          uuidv4();
      } else {
        src =
          "https://i2e1.in?doTest&res=logoff&uamip=10.1.0.1&uamport=80&challenge=30f8c06d61d8142d81fbdb394640fc13&called=" +
          mockmac() +
          "&mac=" +
          mockmac() +
          "&power=32&ip=10.1.0.2&nasid=" +
          this.selectedLocation.nasid +
          "&sessionid=" +
          uuidv4();
      }
      window.open(src, "_blank");
    },
    GetUserBasicConfig: function() {
      WIOM_APIS.getUserBasicConfig(this.settingId)
        .then(response => {
          console.log(response)
          this.basicConfiguration = response.data;
          this.setting.landingUrl = this.basicConfiguration.basicConfigs.LANDING_PAGE.value;
          //console.log("get basic settings", this.setting.landingUrl);
        });
    },
    GoToPaymentPage(){
      window.open(`https://wiom.in/wiompayment/subscriptions?pid=10004&nasid=${this.selectedLocation.nasid}`);
    },
    GetAdvancedConfiguration: function() {
      //console.log("get adv conf");
      WIOM_APIS.getAdvanceConfiguration(this.settingId)
        .then(response => {
          //console.log("get advanced settings", response.data.data);
          this.advancedConfiguration = response.data;
          this.setting.logo = this.advancedConfiguration.LOGIN_PAGE_IMAGE.parameters[0];
          if (this.nonPremium()) {
            this.setting.logo = "";
            this.setting.landingUrl = "";
          }
        });
    },
    save: function() {
      this.basicConfiguration.basicConfigs.LANDING_PAGE.value = this.setting.landingUrl;
      this.advancedConfiguration.LOGIN_PAGE_IMAGE.parameters[0] = this.setting.logo;
      WIOM_APIS.setUserBasicConfig({
        settingId: this.settingId,
        userGroups: [{ basicConfigs: this.basicConfiguration.basicConfigs }]
      })
      .then((response) => {
        console.log(response);
      });
      WIOM_APIS.setAdvanceConfiguration({
        settingId: this.settingId,
        advanceConfigs: this.advancedConfiguration
      })
      .then(() => {
        this.popup = {
          visbile: true,
          text: "Settings Saved",
          type: "success"
        };
      });
    },
    filesChange: function(fieldName, fileList) {
      //console.log(fieldName, fileList);
      if (!fileList.length) return;
      const headerPhoto = new FormData();
      // dict of all elements
      headerPhoto.append("file", fileList[0]);
      headerPhoto.append("nameAppender", this.settingId);
      WIOM_APIS.uploadFile(headerPhoto).then(response => {
        this.setting.logo = response;
      });
    }
  },
  watch: {
    settingId: function() {
      this.GetUserBasicConfig();
      this.GetAdvancedConfiguration();
    }
  }
};
</script>
